export const testTokenData = {
  tokenType: 'Bearer',
  isPersisted: true,
  accessToken: 'staticAccessToken123',
  accessTokenExpiresAt: new Date('2024-12-15T10:00:00Z'),
  refreshToken: 'staticRefreshToken123',
  refreshTokenExpiresAt: new Date('2024-12-30T10:00:00Z'),
}
